import React, { useEffect, useState }  from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { routes } from '../../../constantes/routes'
import { TOKEN_KEY } from '../../../constantes/localStorageKeys'
import { infoProfileContactHospitalPresentationActions } from '../../../actions/accessToPresentationByContact/infoProfileContactHospitalPresentationActions'
import { configApi } from '../../../api/configApi'
import { swalAlertError } from '../../../utils/swalAlert'

const AccessPresentationRoute = (
    {
        component: Component,
        ...rest
    }
) => {
    const id = rest.computedMatch.params.id
    const infoProfileContactHospitalPresentation = useSelector(state => state.infoProfileContactHospitalPresentation)

    const dispatch = useDispatch()
    const getInfoContactHospitalPresentation = () => dispatch(infoProfileContactHospitalPresentationActions.getInfoProfileContactHospitalPresentation(id))
    
    const [toRoute, setToRoute] = useState('')

    useEffect(async () => {
        const authStatus = await configApi.getAuthStatus()
        setToRoute(goToProtectedPage(authStatus.data))
        getInfoContactHospitalPresentation()
    }, [])

    useEffect(() => {
    }, [ toRoute, infoProfileContactHospitalPresentation])

    const goToProtectedPage = (enableAuth) =>{
        if(enableAuth){
            return (
                <Route
                    {...rest}
                    render={props =>
                        localStorage.getItem(TOKEN_KEY) && infoProfileContactHospitalPresentation?.id_ContactoPresentacion ? (
                            <Redirect to={{ pathname: routes.VIEW_CONTACT_PRESENTATION + id }} />
                        ) : (
                            <Component {...props} /> 
                        )
                    }
                />
            )
        }
        return (
            <Redirect to={{ pathname: routes.VIEW_CONTACT_PRESENTATION + id }} />  
        )
    }

    return (
        <>
            { toRoute }
        </>
    )
}

export default AccessPresentationRoute
